import { AuthenticatedNotification, BroadcastUserChannelType } from "@/enums/enums";
import {
  DoDeleteNotificationById,
  DoGetAllNotificationList,
  DoGetIsSeenNotificationList,
  DoGetUnSeenNotificationList,
  DoGetUnseenNotificationCount,
  DoSetNotificationIsSeenAll,
  DoSetNotificationIsSeenById,
  SocketDisconnect,
} from "@/helper/notificationHelper";
import {
  GetTabById,
  GetTabIdFromSessionStorage,
  InsertTabIdToTabDB,
  IsMasterTab,
  UpdateTabMerchantId,
} from "@/helper/tabHelper";
import { MerchantId } from "@/helper/userHelper";
import store from "@/store";

let userChannel: BroadcastChannel | null = null;

export const BroadcastInUserChannel = () => {
  if (userChannel) {
    userChannel.postMessage("Test");
  }
};

export const BroadcastUserMasterChannel = () => {
  if (userChannel) {
    userChannel.postMessage("toUserChannelMaster");
  }
};

export const BroadcastAuthenticatedNotificationStatus = (
  authenticatedNotificationStatus: AuthenticatedNotification
) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.AuthenticatedNotification,
      request: {
        authenticatedNotificationStatus: authenticatedNotificationStatus,
      },
    });
  }
};

export const BroadcastDisconnectNotification = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.DisconnectNotification,
      request: null,
    });
  }
};

export const BroadcastIsUpdateNotificationCount = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.UpdateNotificationCount,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateNotificationList = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.UpdateNotificationList,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateUnSeenNotificationList = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.UpdateUnSeenNotificationList,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateIsSeenNotificationList = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.UpdateIsSeenNotificationList,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateIsSeenNotificationFromActionIsSeen = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.UpdateIsSeenNotificationFromActionIsSeen,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterDeleteNotificationById = (merchantId: number, notificationId: string, isSeen: boolean) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.MasterDeleteNotificationById,
      request: {
        merchantId: merchantId,
        notificationId: notificationId,
        isSeen: isSeen,
      },
    });
  }
};

export const BroadcastMasterGetNotificationListByMerchantId = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.MasterGetNotificationListByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterGetUnSeenNotificationListByMerchantId = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.MasterGetUnSeenNotificationListByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterGetIsSeenNotificationListByMerchantId = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.MasterGetIsSeenNotificationListByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterGetNotificationCountByMerchantId = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.MasterGetNotificationCountByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastDisconnectNotificationAllTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.DisconnectNotificationAllTab,
      request: null,
    });
  }
};

export const BroadcastReCreateTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.ReCreateTab,
      request: null,
    });
  }
};

export const BroadcastMasterSetNotificationIsSeenAll = (merchantId: number) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.MasterSetNotificationIsSeenAll,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterSetNotificationIsSeenById = (merchantId: number, notificationId: string) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.MasterSetNotificationIsSeenById,
      request: {
        merchantId: merchantId,
        notificationId: notificationId,
      },
    });
  }
};

const AuthenticatedNotificationFromBroadcast = (authenticatedNotificationStatus: AuthenticatedNotification) => {
  if (authenticatedNotificationStatus == AuthenticatedNotification.Success) {
    store.commit("Notification/MutationSetNotificationReadyToUse", true, { root: true });
  } else {
    store.commit("Notification/MutationSetNotificationReadyToUse", false, { root: true });
  }
};

const DisconnectNotificationFromBroadcast = () => {
  store.commit("Notification/MutationSetNotificationReadyToUse", false, { root: true });
};

const UpdateNotificationCountFromBroadcast = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  const tab = await GetTabById(tabId);

  if (tab && tab.merchantId == merchantId) {
    await store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
  }
};

const UpdateNotificationListFromBroadcast = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  const tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.dispatch("Notification/ActionSetNotificationListFromIndexedDB", null, { root: true });
  }
};

const UpdateUnSeenNotificationListFromBroadcast = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  const tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
  }
};

const UpdateIsSeenNotificationListFromBroadcast = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  const tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
  }
};

const UpdateIsSeenNotificationFromActionIsSeenFromBroadcast = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  const tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.dispatch("Notification/ActionSetNotificationFromActionIsSeen", null, { root: true });
  }
};

const MasterDeleteNotificationByIdFromBroadcast = (merchantId: number, notificationId: string, isSeen: true) => {
  if (IsMasterTab()) {
    DoDeleteNotificationById(merchantId, notificationId, isSeen);
  }
};

const MasterGetNotificationListByMerchantIdFromBroadcast = (merchantId: number) => {
  if (IsMasterTab()) {
    DoGetAllNotificationList(merchantId);
  }
};

const MasterGetUnSeenNotificationListByMerchantIdFromBroadcast = (merchantId: number) => {
  if (IsMasterTab()) {
    DoGetUnSeenNotificationList(merchantId);
  }
};

const MasterGetIsSeenNotificationListByMerchantIdFromBroadcast = (merchantId: number) => {
  if (IsMasterTab()) {
    DoGetIsSeenNotificationList(merchantId);
  }
};

const MasterGetNotificationCountByMerchantIdFromBroadcast = (merchantId: number) => {
  if (IsMasterTab()) {
    DoGetUnseenNotificationCount(merchantId);
  }
};

const DisconnectNotificationAllTabFromBroadcast = () => {
  SocketDisconnect();
  store.commit("Notification/SOCKET_disconnect", null, { root: true });
};

const ReCreateTabFromBroadcast = async () => {
  const merchantId = MerchantId();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
  BroadcastMasterGetNotificationCountByMerchantId(merchantId);
};

const MasterSetNotificationIsSeenAllFromBroadcast = async (merchantId: number) => {
  if (IsMasterTab()) {
    DoSetNotificationIsSeenAll(merchantId);
  }
};

const MasterSetNotificationIsSeenByIdFromBroadcast = async (merchantId: number, notificationId: string) => {
  if (IsMasterTab()) {
    await DoSetNotificationIsSeenById(merchantId, notificationId);
  }
};

export const SetUserChannel = (userId: number) => {
  if (userChannel) {
    userChannel.close();
  }
  userChannel = new BroadcastChannel(userId.toString());

  userChannel.onmessage = async (event) => {
    if (event.data) {
      switch (event.data.broadcastType) {
        case BroadcastUserChannelType.AuthenticatedNotification:
          AuthenticatedNotificationFromBroadcast(event.data.request.authenticatedNotificationStatus);
          break;
        case BroadcastUserChannelType.DisconnectNotification:
          DisconnectNotificationFromBroadcast();
          break;
        case BroadcastUserChannelType.UpdateNotificationCount:
          UpdateNotificationCountFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.UpdateNotificationList:
          UpdateNotificationListFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.MasterDeleteNotificationById:
          MasterDeleteNotificationByIdFromBroadcast(
            event.data.request.merchantId,
            event.data.request.notificationId,
            event.data.request.isSeen
          );
          break;
        case BroadcastUserChannelType.MasterGetNotificationListByMerchantId:
          MasterGetNotificationListByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.MasterGetNotificationCountByMerchantId:
          MasterGetNotificationCountByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.DisconnectNotificationAllTab:
          DisconnectNotificationAllTabFromBroadcast();
          break;
        case BroadcastUserChannelType.ReCreateTab:
          ReCreateTabFromBroadcast();
          break;
        case BroadcastUserChannelType.MasterSetNotificationIsSeenAll:
          MasterSetNotificationIsSeenAllFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.UpdateUnSeenNotificationList:
          UpdateUnSeenNotificationListFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.UpdateIsSeenNotificationList:
          UpdateIsSeenNotificationListFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.MasterGetUnSeenNotificationListByMerchantId:
          MasterGetUnSeenNotificationListByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.MasterGetIsSeenNotificationListByMerchantId:
          MasterGetIsSeenNotificationListByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case BroadcastUserChannelType.MasterSetNotificationIsSeenById:
          MasterSetNotificationIsSeenByIdFromBroadcast(
            event.data.request.merchantId,
            event.data.request.notificationId
          );
          break;

        case BroadcastUserChannelType.UpdateIsSeenNotificationFromActionIsSeen:
          UpdateIsSeenNotificationFromActionIsSeenFromBroadcast(event.data.request.merchantId);
          break;
      }
    }
  };
};
